/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './styles.scss';
import LessonNavLink from './LessonNavLink';

const LessonNavItem = ({ chunks, chunkVisits, buildChunkUrl }) => {
  const hasChunkVisit = (chunkId) =>
    chunkVisits.find((chunkVisit) => chunkVisit.get('chunk') === chunkId);

  const links = chunks.map((chunk) => (
    <LessonNavLink
      key={chunk.get('id')}
      url={buildChunkUrl(chunk.get('index'))}
      chunk={chunk}
      hasChunkVisit={hasChunkVisit(chunk.get('id'))}
    />
  ));

  return <li className={cx({ [s.grouped]: chunks.length > 1 })}>{links}</li>;
};

LessonNavItem.propTypes = {
  chunks: PropTypes.any,
  chunkVisits: PropTypes.any,
};

export default LessonNavItem;
